"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgDashboard(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M8 6H4v10h4zm0-6H4v4h4zm6 12h-4v4h4zM10 0v10h10V0zm10 12h-4v4h4z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Dashboard')(SvgDashboard);
//# sourceMappingURL=Dashboard.js.map